import React from "react";
import { Container } from "react-bootstrap";

const ACTION_MESSAGES = {
  completed: 'Gracias por firmar el documento',
  cancel: 'Usted ha salido de la sesión de firma. Recuerde que el documento aún no quedó firmado. Vuelva a ingresar a la plataforma para finalizar el proceso.',
  declined: 'Hemos registrado su disconformidad con la firma del documento. Su asesor quedará notificado y en breve se estará comunicando con usted para repasar la razón por la cual decidió no firmar. También puede contactarse con su asesor si así lo desea.',
  voided: 'El documento fue anulado por Balanz.',
};

const SubDocumentComplete = ({ type }) => {
    return (
        <>
            <div className="headerModal d-flex align-items-center justify-content-center mb-5" style={{color:"white", fontSize:"40px", textAlign:"center", fontWeight:"bold"}}>BALANZ-IFA DOCUMENTO</div>
            <Container>
                <div className="message-info">
                    <p className='my-3 text-center'>
                        {ACTION_MESSAGES[type] || 'Gracias'}
                    </p>
                </div>
            </Container>
        </>
    );
}

export default SubDocumentComplete;
